import React from 'react';
import Stars from 'src/data/images/stars.svg';
import { mediaQueries } from 'src/style/breakpoints';

const StarsCTAFooter = () => {
  return (
    <div
      css={{
        position: 'absolute',
        backgroundImage: `url(${Stars})`,
        backgroundSize: 'contain',
        [mediaQueries.phoneOnly]: {
          width: '100%',
          height: 120,
          top: -30,
        },
        [mediaQueries.tabletPortraitUp]: {
          width: '100%',
          height: 150,
          top: -55,
        },
        [mediaQueries.tabletLandscapeUp]: {
          width: 740,
          height: 150,
          top: -50,
        },
      }}
    />
  );
};
export default StarsCTAFooter;
